import { create } from 'zustand'

export type Screen =
  | { name: 'overview' }
  | { name: 'centres-management' }
  | { name: 'student'; userId: string; firstName: string }

interface RouterState {
  screen: Screen
  navigateToStudent(userId: string, firstName: string): void
  navigateToCentresManagement(): void
  navigateToOverview(): void
}

export const useRouter = create<RouterState>((set) => ({
  screen: { name: 'overview' },
  navigateToStudent: (userId, firstName) =>
    set({ screen: { name: 'student', userId, firstName } }),
  navigateToCentresManagement: () =>
    set({ screen: { name: 'centres-management' } }),
  navigateToOverview: () => set({ screen: { name: 'overview' } }),
}))
